import Google from "../shared/googleapi.js"
import GoogleTasks from "./tasks-data.js"
import StatusBar from "../shared/statusbar.js"
import Menu from "../shared/menu.js"
import m from "mithril"
import moment from "moment"

import FuzzyClock from "../fuzzy/fuzzy.js"

import "./tasks-view.css"
var reloadTimeout = null;
var TaskRootContainer = {
  oninit: function() {
    Google.load(function() {
      Google.clientInit().then(function() {
        if (Google.isSignedIn()) { GoogleTasks.fetchIfNeeded(); }
        gapi.auth2.getAuthInstance().isSignedIn.listen(function(isSignedIn) {
          if (!isSignedIn) { GoogleTasks.clearData(); }
        });
      });
    });
  },
  
  onremove: function() {
    clearTimeout(reloadTimeout)
  },
  signOut: function() {
    Google.signOut();
    location.clearAndReload();
  },
  view: function(vnode) {
    var attrs = vnode.attrs;
    var taskData = GoogleTasks.getData();
  
    if (!Google.isReady()) {
      return m(StatusBar)
    }
    if (Google.isSignedIn() == false) {
      if (isWidget) return undefined;
      return (Google.signInContent());
    } 

    var menu = {items: [
      { title:"Refresh", onclick: function() { GoogleTasks.fetch(); } }, 
      { title:"Reload Page", onclick: function() { location.clearAndReload(); } }, 
      { title:"Redraw Page", onclick: function() { document.redraw(true); } }, 
      { title:"Sign out", onclick: function() { TaskRootContainer.signOut(); }}
    ]}
    
    var components = []

    var isWidget = attrs && (attrs.class == "widget")
    if (!isWidget) {
      components = [
        m(StatusBar),
        this.standalone ? m(Menu, menu) : undefined,
        m(FuzzyClock, {class:"widget", onclick:function(){GoogleTasks.fetch()}})
      ];
    }
    if (!taskData) {
      GoogleTasks.fetchIfNeeded();
      
      // if (!reloadTimeout) reloadTimeout = setTimeout(function(){ location.reload() }, 60000);
        {
        components.push(
          m('div', {class:'status', onclick: function() {location.reload()}}, '...'));
  
      }
    } else {
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
        reloadTimeout = null;
      }
      components.push(m(TaskListContainer))
    }

    return m("div#tasks-container", {class: isWidget ? "widget" : ""},components);
  }
}

var TaskListContainer = {
  view: function() {
    var taskInfo = GoogleTasks.getData();

    if (!taskInfo) return "No Task Data"
    var taskLists = taskInfo.taskLists;
    if (!taskLists) return "No Tasks"

    if (false) {
      var children = taskLists.map(function(t){ return m(TaskList, t) });
      return m("div", children)
    }

    var allTasks = []
    var subtasksByParent = {}
    taskLists.forEach(function(list) {
      var tasks = list.items
      if (list.title.indexOf("*") >= 0) return;
      if (!tasks) return;
      tasks.forEach(function(task) {
        task.list = list;
        task.dueDate = task.due ? Date.parseRFC3339(task.due) : undefined;
        task.updatedDate = task.updated ? Date.parseRFC3339(task.updated) : undefined;
        if (task.parent) {
          if (subtasksByParent[task.parent]) {
            subtasksByParent[task.parent].push(task)
          } else {
            subtasksByParent[task.parent] = [task];
          }
        } else {
          allTasks.push(task)
        }
      });
    });

    var now = new Date()
    function sortByDueDate(a, b) {
      if (b.dueDate && (!a.dueDate || a.dueDate > now || a.dueDate > b.dueDate)) return 1
      if (a.dueDate && (!b.dueDate || b.dueDate > now || a.dueDate < b.dueDate)) return -1
      return 0;
    }
    // Sort
    if (true) {
      allTasks.sort(sortByDueDate);
    }

    var children = [];

    function dateToDescriptor (date) {
        return moment(date).calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: '[Next week]',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: function(now) {
              if (this.isBefore(now)) {
                return '[' + this.fromNow() + ']';
              } else {
                return '[Someday]'
              }
            }
          });
      }
    


    var clusters = {
      "past": {title: "Past", expanded:false, tasks:[]},
      "overdue": {title: "Overdue", tasks:[]},
      "today": {title: "Today", tasks:[]},
      "soon": {title: "Soon", tasks:[]},
      "recent": {title: "Recent", tasks:[]},
      "other": {title: "Tasks", tasks:[]},
      "future": {title: "Future", expanded:false, tasks:[]},
    }

    // Past - < -1 week
    // Overdue - -1 week
    // Today
    // Soon - 1 week
    // No Date - Undated tasks
    // Future - Beyond 1 week

    function addToCluster(task, c) {
      if (!clusters[c]) clusters[c] = [];
      clusters[c].push(task);
    }
    var lastDueDate = new Date(0);
    allTasks.forEach( function(task) {
      if (task.parent !== undefined) return;

      if (task.dueDate) {
        if (task.dueDate < moment().subtract(30, 'days')) { // Old
          clusters['past'].tasks.push(task);
        } else if (task.dueDate < moment().startOf('day')) { // Overdue
          clusters['overdue'].tasks.push(task);
        } else if (task.dueDate < moment().add(1, 'days').startOf('day')) { // Today
          clusters['today'].tasks.push(task);
        } else if (task.dueDate < moment().endOf('week')) { // Soon 
          clusters['soon'].tasks.push(task);
        } else {
          clusters['future'].tasks.push(task);
        }
      } else if (task.updatedDate > moment().startOf('day')){
        clusters['recent'].tasks.push(task);
      } else {
        clusters['other'].tasks.push(task);        
      }
    });

    // Rotate tasks
    var oTasks = clusters['other'].tasks
    var n = (now.getDate() + now.getHours()) % oTasks.length;
    oTasks = oTasks.slice(n, oTasks.length).concat(oTasks.slice(0, n));
    clusters['other'].tasks = oTasks;

    var clusterElements = []
    var orderedClusters = ["past", "overdue", "today", "soon", "recent", "other", "future"]
    orderedClusters.forEach(function(clusterName) {
      var cluster = clusters[clusterName];
      var element = m(TaskCluster, {key: clusterName, data:cluster, subtasks:subtasksByParent});
      if (element) clusterElements.push(element)
    })


    return m("main", clusterElements)

  }
}

var TaskCluster = {
  expanded: true,
  oninit: function(vnode) {
    if (vnode.attrs.data.expanded != undefined) {
      vnode.state.expanded = vnode.attrs.data.expanded
    }
  },
  view: function(vnode) {
    var expanded = vnode.state.expanded;
    var cluster = vnode.attrs.data;

    var title = cluster.title;
    var classList = ["taskCluster"];
    if (vnode.state.expanded) classList.push("expanded");

    var children = [];
    cluster.tasks.forEach(function(task){
    var subtasksByParent = vnode.attrs.subtasks;
      const subtasks = subtasksByParent[task.id]
      var subTaskCells; 
      if (subtasks) {
        subTaskCells = subtasks.map(function(subtask) {
          return m(Task, {key:subtask.id, data:subtask, list:subtask.list, parent:task.id, class:'subtask'});
        });
      }
      children.push(m('div', {key:task.id + '-group', class:"taskGroup"}, [m(Task, {key:task.id, data:task, list:task.list}), subTaskCells]));

    })
  
    if (!children.length) return null;
    return m('section', {id:"task-cluster-" + vnode.attrs.key, class:classList.join(" ")},
      m('div', { class:'cluster'}, 
        m('div', {class:'cluster-header', onclick:function() {
          vnode.state.expanded = !vnode.state.expanded;
        }},
          m('div', {class:'title h3'}, [title.toUpperCase(), m('span', {class:'count'}, children.length)])
        ),
        m('div', {class:'cluster-inner'}, children)
      )
    );
  }
}

var Task = {
  checked: false,
  expanded: false,
  parseDate: function(input) {
    var parts = input.substring(0,10).split('-');
    return new Date(parts[0], parts[1]-1, parts[2]);
  },
  view: function(vnode) {
    var checked = vnode.state.checked;
    var task = vnode.attrs.data;
    var list = vnode.attrs.list;
    var classList = ['task'];
    classList.push(vnode.attrs.class);
    if (checked) classList.push("checked");
    if (vnode.state.expanded) classList.push("expanded");
    var date = task.due ? this.parseDate(task.due) : undefined;
var now = new Date()
    function dateToDescriptor (date) {
        return moment(date).calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: '[Next week]',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: function(now) {
              if (this.isBefore(now)) {
                return '[' + this.fromNow() + ']';
              } else {
                return '[Someday]'
              }
            }
          });
      }
    var hasNotes = task.notes;
    if (hasNotes) classList.push("hasNotes");
    var hideList = (list.title == 'My Tasks' || list.title == 'To Do')

    var tags = []

    if (!hideList) tags.push(list.title)
    if (date) tags.push(dateToDescriptor(date))
    var listName = hideList ? undefined : m("div", {class:"list"}, list.title);
    var dateName = date ? m("div", {class:"list"}, dateToDescriptor(date)): undefined;

    return m("div", {class:classList.join(" ")}, [
        tags ? m("div", {class:"list"}, tags.join("\n")) : undefined,

        // m("time", relativeDate(date)),
        m("span", {
          class:"checkbox" + (checked ? " checked" : ""),
          id:task.id,
          onclick: function() {
            var patch = vnode.state.checked ? 
            { status: 'needsAction', completed: null } :
            { status: 'completed' }  
            GoogleTasks.updateTask(task.id, list.id, patch)
            vnode.state.checked = !vnode.state.checked;
          }}, m('div', {class:'box'})),
        m("label", {for:task.id,onclick:function() {
          vnode.state.expanded = !vnode.state.expanded;
        }}, m.trust(linkify(task.title))),
        m("div", {class:"expando"}, "..."),
        m("div", {class:"notes"}, m.trust(linkify(task.notes))),
    ])
  }
}



module.exports = TaskRootContainer